<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
            <v-text-field
              label="Address"
              v-model="model.address"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" sm="6" :class="classPadding">
            <v-text-field
              label="City"
              v-model="model.city"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" sm="6" :class="classPadding">
            <v-autocomplete
              label="Province"
              v-model="model.province"
              :items="provinces"
              item-value="code"
              item-text="description"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3" sm="6" :class="classPadding">
            <v-text-field
              label="Zip Code"
              v-model="model.zipCode"
              autocomplete="off"
            ></v-text-field>
          </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import isEmpty from "lodash/isEmpty"
import { mapActions, mapState } from "vuex"
export default {
  props: [
    "value"
  ],
  data: () => ({
    classPadding: "my-0 py-0",
    model: {},
  }),
  methods: {
    ...mapActions("province", ["getAllProvinces"]),
    emitValue() {
      this.$emit("input", this.model);
    }
  },
  computed: {
     ...mapState("province", {
      provLoading: state => state.loading,
      provinces: state => state.provinces
    }),
  },
  created() {
    this.getAllProvinces();
  },
  watch: {
    model: {
      handler(val){
        this.$emit("input", val);
      },deep: true
    }
  },
  mounted() {
    if(!isEmpty(this.value)){
       this.model = Object.assign({},{ ...this.value });
    }
  }
}
</script>